
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class InvalidResetTokenCard extends Vue {
  @Prop({ type: String, default: null })
  private readonly reason!: string

  @Prop({ type: Boolean, default: false })
  private readonly noRenew!: boolean

  get description() {
    switch (this.reason) {
      case 'expired':
        return 'This link has expired.'
      case 'used':
        return 'This link has been used.'
      default:
        return 'This link is invalid.'
    }
  }

  requestNewLink() {
    this.$router.push({ name: 'forgot-password' })
  }
}
